import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { Facebook2, Instagram2, Messeges2,WebsiteIcon} from "./Icon";
import { TokenItem } from "./Launchpad";
import MarqueeSection from "./MarqueeSection";
import TokenChart from "./TokenChart";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useAnchorWallet } from '@solana/wallet-adapter-react';
import * as anchor from '@project-serum/anchor';
import idl from '../assets/IDL/idl.json';
import toast, { Toaster } from 'react-hot-toast';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons'; // For website icon
import { faBook } from '@fortawesome/free-solid-svg-icons'; // For documentation
import { faCopy } from '@fortawesome/free-solid-svg-icons'; // For documentation

import { faTwitter, faTelegramPlane } from '@fortawesome/free-brands-svg-icons'; // For Twitter and Telegram

import CountdownCard from "./Countdown";
import ReactSelectSearch from 'react-select-search';
import 'react-select-search/style.css'







const TokenDetailsSection2 = () => {
	const [tab, setTab] = useState("overview");

		const [copied, setCopied] = React.useState(false);
		const [amount, setAmount] = useState('');
		const [currentContribution, setCurrentContribution] = useState(0);


		const [maxPoolSize, setMaxPoolSize] = useState(0);
        const [totalContributed, setTotalContributed] = useState(0);
		const [options, setOptions] = useState([]);


		  const wallet = useAnchorWallet();
		  const customRpcUrl = `https://mainnet.helius-rpc.com/?api-key=${process.env.REACT_APP_API_KEY}`;

		  // Creating a connection object with the custom RPC URL
		  const connection = new anchor.web3.Connection(
			  customRpcUrl,
			  'confirmed'
		  );

		  const targetDate = new Date(); // Get the current date and time

		  // Convert current date to UTC, then set hours to 15 (3 PM in 24-hour format), minutes, seconds, and milliseconds to 0 for 3 PM UTC
		  targetDate.setUTCHours(15, 0, 0, 0);

		  // If the current time is past 3 PM UTC, set the target date to 3 PM UTC the next day
		  if (new Date() > targetDate) {
			  targetDate.setUTCDate(targetDate.getUTCDate() + 1);
		  }

		const fetchPresaleData = async () => {
			const provider = new anchor.AnchorProvider(connection, wallet, anchor.AnchorProvider.defaultOptions());

			const programId = '8XTBVHf1ru1aZToJwpjw5waJNK1jN6zyw2uQq5jChS7e'; // Replace with your actual program ID
			const program = new anchor.Program(idl, programId, provider);

			const [presaleAccountPda, _] = await anchor.web3.PublicKey.findProgramAddress(
				[Buffer.from("sol666")],
				program.programId
			);


			try {
				const presaleAccountInfo = await program.account.presaleAccount.fetch(presaleAccountPda);
				console.log(presaleAccountInfo)
				setMaxPoolSize(presaleAccountInfo.maxPoolSize.toNumber() / anchor.web3.LAMPORTS_PER_SOL);
				setTotalContributed((presaleAccountInfo.totalContributed.toNumber() / anchor.web3.LAMPORTS_PER_SOL) + 0.1);
				console.log(maxPoolSize,totalContributed)
			} catch (error) {
				console.error('Error fetching presale data:', error);
			}
		};

		useEffect(() => {
			fetchPresaleData();
			const intervalId = setInterval(fetchPresaleData, 5000);

			return () => clearInterval(intervalId); // Clean up interval on unmount
		}, []);


		const fetchWL = async () => {



			const provider = new anchor.AnchorProvider(connection, wallet, anchor.AnchorProvider.defaultOptions());
			const programId = new anchor.web3.PublicKey('8XTBVHf1ru1aZToJwpjw5waJNK1jN6zyw2uQq5jChS7e'); // Use your actual program ID here
			const program = new anchor.Program(idl, programId, provider);

			// Assuming the whitelist PDA is generated with specific seeds known to your program
			const [whitelistPda, _] = await anchor.web3.PublicKey.findProgramAddress(
			  [Buffer.from("white666")], // The seed used to generate the PDA for the whitelist
			  program.programId
			);

			try {
			  const whitelistAccountInfo = await program.account.whitelistAccount.fetch(whitelistPda);
			  const newOptions = whitelistAccountInfo.whitelistedAddresses.map((address, index) => ({
				name: address.toString(), // Customize the name format as needed
				value: address.toString(),
			  }));

			  setOptions(newOptions);
			} catch (error) {
			  console.error('Error fetching whitelist data:', error);
			}
		  };

		  useEffect(() => {
			fetchWL(); // Call it once initially
			const intervalId = setInterval(fetchWL, 50000); // and then every 5 minutes (300000 milliseconds)

			return () => clearInterval(intervalId); // Clean up the interval on unmount
		  }, []);


		  const fetchCurrentContribution = async () => {
			if (!wallet) {
			  console.log('Wallet not connected');
			  return;
			}

			const provider = new anchor.AnchorProvider(connection, wallet, anchor.AnchorProvider.defaultOptions());
			const programId = new anchor.web3.PublicKey('8XTBVHf1ru1aZToJwpjw5waJNK1jN6zyw2uQq5jChS7e'); // Your actual program ID here
			const program = new anchor.Program(idl, programId, provider);

			const [presaleAccountPda, _] = await anchor.web3.PublicKey.findProgramAddress(
				[Buffer.from("sol666")],
				program.programId
			);

			try {
			  const presaleAccountInfo = await program.account.presaleAccount.fetch(presaleAccountPda);
			  const userContribution = presaleAccountInfo.contributions.find(contribution => contribution.user.toString() === wallet.publicKey.toString());

			  if (userContribution) {
				const amountInSol = userContribution.amount / anchor.web3.LAMPORTS_PER_SOL; // Convert from lamports to SOL
				setCurrentContribution(amountInSol);
				console.log(amountInSol)
			  } else {
				setCurrentContribution(0); // No contribution found, set to 0
			  }
			} catch (error) {
			  console.error('Error fetching current contribution:', error);
			}
		  };

		  useEffect(() => {
			fetchCurrentContribution(); // Fetch once on component mount
			const intervalId = setInterval(fetchCurrentContribution, 60000); // Refresh every 1 minute

			return () => clearInterval(intervalId); // Clean up the interval on unmount
		  }, [wallet, connection]); // Re-run when wallet or connection changes







		const handleAmountChange = (e) => {
			setAmount(e.target.value);
		};


		const notifySuccess = (min) => {
			toast.success('Successfully Contributed'+" "+min+"SOL");
		};
		const notifyfailed = () => {
			toast.error('ERROR');
		};


        const WhitelistSearch = ({ options }) => {
            const [searchTerm, setSearchTerm] = useState('');
            const [copiedIndex, setCopiedIndex] = useState(null);

            const filteredAddresses = options.filter(option =>
              option.value.toLowerCase().includes(searchTerm.toLowerCase())
            );

            const handleCopy = (index) => {
              setCopiedIndex(index);
              setTimeout(() => setCopiedIndex(null), 2000);
            };

            return (
              <div className="inner-div">
                <div className="mb-4">
                  <input
                    type="text"
                    className="form-control poppins"
                    placeholder="Search addresses..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      background: '#1a1b23',
                      border: '1px solid #2c2d33',
                      borderRadius: '8px',
                      color: '#fff',
                      padding: '12px 16px',
                      '::placeholder': { color: '#fff' }
                    }}
                  />
                  <style>
                    {`
                      .form-control::placeholder {
                        color: #fff !important;
                        opacity: 0.7;
                      }
                    `}
                  </style>
                </div>

                <div className="whitelist-addresses" style={{
                  maxHeight: '400px',
                  overflowY: 'auto',
                  background: '#1a1b23',
                  borderRadius: '8px',
                  padding: '16px'
                }}>
                  {filteredAddresses.length > 0 ? (
                    <ul className="list-unstyled m-0">
                      {filteredAddresses.map((address, index) => (
                        <li
                          key={index}
                          className="mb-2 p-3 d-flex justify-content-between align-items-center"
                          style={{
                            background: '#2c2d33',
                            borderRadius: '6px',
                            fontSize: '14px',
                            wordBreak: 'break-all',
                            color: '#fff'
                          }}
                        >
                          <span style={{ flex: 1 }}>{address.value}</span>
                          <CopyToClipboard
                            text={address.value}
                            onCopy={() => handleCopy(index)}
                          >
                            <button
                              className="btn btn-sm ms-2"
                              style={{
                                background: 'transparent',
                                border: 'none',
                                padding: '4px 8px',
                                color: copiedIndex === index ? '#90EE90' : '#fff',
                                cursor: 'pointer',
                                transition: 'color 0.3s ease'
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faCopy}
                                size="1x"
                              />
                            </button>
                          </CopyToClipboard>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="text-center py-4" style={{ color: '#fff' }}>
                      No addresses found
                    </div>
                  )}
                </div>

                {/* <div className="mt-3 text-end" style={{ color: '#fff' }}>
                  Total addresses: {filteredAddresses.length}
                </div> */}
              </div>
            );
          };











	return (
		<><Toaster
		position="top-center"
		reverseOrder={false}
		gutter={8}
		containerClassName=""
		containerStyle={{}}
		toastOptions={{
		  // Define default options
		  className: 'sfprotext-semi-bold-violet-20px',
		  duration: 5000,
		  style: {
			background: '#90EE90', /* Black background */
			color: '#000000', /* Light green text */
		},

		  // Default options for specific types
		  success: {
			duration: 3000,
			theme: {
			  primary: 'green',
			  secondary: 'black',
			},
		  },
		}}
	  />
		<section className="token-details-section">
			<MarqueeSection />
			<div className="pt-5">
				<div className="container poppins">
					<div className="d-flex flex-wrap gap-4 justify-content-center justify-content-sm-start gap-xl-57">
						<div className="bigger-block">
							<div className="token-details poppins">
								<div
									className="token-details-top"
									style={{
										background: `url('/img/solchat77.png') center top -40px / cover`,
									}}
								>
								<div className="w-100" style={{ backgroundColor: "#000", padding: "10px" }}>
									<div className="d-flex align-items-center justify-content-between" style={{ marginBottom: "10px" }}>
										<div className="d-flex align-items-center gap-3">
										<div
											style={{
												borderRadius: "50%",
												border: "4px solid",
												borderImage: "linear-gradient(135deg, #8e44ad, #3498db) 1",
												padding: "5px",
												width: "70px",
												height: "70px",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												backgroundColor: "#000"
											}}
										>
											<img className="img" src={"/img/solchatmini1.png"} alt="" width={50} />
										</div>
										<h6 style={{ color: "#fff", fontSize: "1.5rem", margin: 0 }}>Solchat</h6>
										</div>
										<div className="d-flex gap-2">
										<Link to="https://www.solchat.io/">
											<div className="icon-block globe-icon">
											<FontAwesomeIcon size="lg" icon={faGlobe} style={{ color: "#000" }} />
											</div>
										</Link>
										<Link to="https://x.com/solchatcoin">
											<div className="icon-block twitter-icon">
											<FontAwesomeIcon size="lg" icon={faTwitter} style={{ color: "#000" }} />
											</div>
										</Link>
										<Link to="https://t.me/SolChatCoin">
											<div className="icon-block telegram-icon">
											<FontAwesomeIcon size="lg" icon={faTelegramPlane} style={{ color: "#000" }} />
											</div>
										</Link>
										<Link to="https://docs.solchat.io/">
											<div className="icon-block book-icon">
											<FontAwesomeIcon size="lg" icon={faBook} style={{ color: "#000" }} />
											</div>
										</Link>
										</div>
									</div>
									<style>
										{`
										.icon-block {
											width: 40px;
											height: 40px;
											display: flex;
											justify-content: center;
											align-items: center;
											background: linear-gradient(135deg, #8e44ad, #3498db);
											border-radius: 10px;
											transition: transform 0.3s ease, box-shadow 0.3s ease;
										}
										.icon-block:hover {
											transform: scale(1.1);
											box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
										}
										@media (max-width: 768px) {
											.icon-block {
											width: 20px;
											height: 20px;
											}
											.icon-block .fa-lg {
											font-size: 0.75em;
											}
										}
										`}
									</style>
									</div>
								</div>
								<div className="token-details-bottom">
									<div className="token-details-tabs mb-4">
										<button
											type="button"
											className={`tab-btn ${
												tab === "overview" ? "active" : ""
											}`}
											onClick={() => setTab("overview")}
										>
											<span>Overview</span>
										</button>
										<button
											type="button"
											className={`tab-btn ${
												tab === "tokenomics" ? "active" : ""
											}`}
											onClick={() => setTab("tokenomics")}
										>
											<span>Tokenomics</span>
										</button>
										<button
											type="button"
											className={`tab-btn ${
												tab === "info-stats" ? "active" : ""
											}`}
											onClick={() => setTab("info-stats")}
										>
											<span>Whitelists</span>
										</button>
									</div>
									{tab === "overview" ? (
										<div className="inner-div">
											<div className="kyc-button-tags position-relative justify-content-start p-0">
												<span className="kyc-button-tag">KYC</span>
												{/* <span className="kyc-button-tag">
													Audit
												</span> */}
												<span className="kyc-button-tag">Safu</span>
												<span className="kyc-button-tag">Tech</span>
											</div>
											{/* <h5>Presale Address</h5>
											<h6 className="text-16 font-semibold">
											HSn2hT7mFEKj9FwSvq6qXZqgSW41d1U92UFQkANLC1tC
												</h6>
											<iframe
												width="630"
												height="321"
												src="https://www.youtube.com/embed/isFB5Tk6kPo?si=fXtJZLvk7cTuKjka"
												title="Solana Update"
												frameborder="0"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
												allowfullscreen
												className="mb-3"
											></iframe> */}
											<p className="text-60">
											Solana is currently a leading blockchain with lower gas fees. Therefore, we have introduced a communication protocol on Solana called Solchat. Users can text, voice call, video call, and do many other things similar to Web2, but in a Web3 environment. Solchat leverages the power of Solana, ensuring all messages and group chats are stored on-chain. Audio and video calls are facilitated peer-to-peer via WebRTC, eliminating the need for a database and preventing leaks. Privacy is our top priority, with every interaction encrypted.
											</p>
										</div>
									) : tab === "tokenomics" ? (
                                        <div className="inner-div">
                                          <TokenChart />
                                          <div className="tokenomics-table" style={{
                                            background: '#1a1b23',
                                            borderRadius: '12px',
                                            padding: '24px',
                                            marginTop: '24px',
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                          }}>
                                            <table style={{
                                              width: '100%',
                                              borderCollapse: 'separate',
                                              borderSpacing: '0 8px'
                                            }}>
                                              <tbody>
                                                <tr>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#808080',
                                                    width: '40%',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '8px 0 0 8px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: '500'
                                                  }}>
                                                    Token Name
                                                  </td>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#fff',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '0 8px 8px 0',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                  }}>
                                                    SolChat
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#808080',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '8px 0 0 8px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: '500'
                                                  }}>
                                                    Token Symbol
                                                  </td>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#fff',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '0 8px 8px 0',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                  }}>
                                                    $CHAT
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#808080',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '8px 0 0 8px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: '500'
                                                  }}>
                                                    Total Supply
                                                  </td>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#fff',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '0 8px 8px 0',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                  }}>
                                                    10,000,000 (10M)
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#808080',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '8px 0 0 8px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: '500'
                                                  }}>
                                                    Liquidity Pool
                                                  </td>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#fff',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '0 8px 8px 0',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                  }}>
                                                    20% of SOL raised
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>

                                            <div style={{
                                              marginTop: '24px',
                                              padding: '16px 24px',
                                              background: '#2c2d33',
                                              borderRadius: '8px',
                                              color: '#fff',
                                              fontSize: '14px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: '12px'
                                            }}>
                                              <div style={{
                                                minWidth: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                backgroundColor: '#90EE90'
                                              }}></div>
                                              <span style={{ lineHeight: '1.5' }}>
                                                20% of the SOL raised from the presale will be allocated for the Liquidity Pool (LP)
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : tab === "info-stats" ? (
                                        <WhitelistSearch options={options} />
                                    ) : null}
								</div>
							</div>
						</div>
						<div className="smaller-block">
							<div
								style={{ maxWidth: "378px" }}
								className="mx-auto me-lg-0"
							>
								<div style={{ maxWidth: "313px" }} className="mx-auto">
									<div className="__progress-item">
											<label className="form-label">WL Presale</label>
											<div className="__progress">
												<div
													className="progress-bar"
													style={{ width: `${(500/ 500) * 100}%` }}
												></div>
											</div>
											<div className="d-flex justify-content-between mt-10">
												<span>500/ 500SOL</span>
												<div>
													<span className="gradient">{((500 / 500) * 100).toFixed(2)}%</span>
													<span className="text-sm">Current Progress</span>
												</div>
											</div>
										</div>
									<form className="mb-5" >
									<div className="max-buy-form">
										<div className="input position-relative">
										<input
											type="number"
											className="form-control poppins"
											id="max"
											placeholder="0"
											value={amount}
											onChange={handleAmountChange}
										/>
										{/* <span className="max-text">MAX</span> */}
										<label htmlFor="max" className="amount">
											amount
										</label>
										</div>
										<button type="submit" className="btn-base">Buy</button>



									</div>
									</form>


									<div className="custom-container">
										{currentContribution !== 0 && (
											<p className="custom-text">
											Your Contribution: {currentContribution} SOL
											</p>
										)}
										</div>

								</div>
								<div className="raise-details">
									<h5 className="title">Raise Details</h5>
									{/* <p>Token Presale Address</p>

									<CopyToClipboard text={value} onCopy={() => setCopied(true)}>
										<button className="copyButton">HSn2hT7mFEKj9FwSvq6qXZqgSW41d1U92UFQkANLC1tC</button>
									</CopyToClipboard>


									{copied ? <span style={{ marginLeft: '10px' }}>Copied!</span> : null} */}

									<br></br>
									<div className="raise-area">
									<div className="raise-item">
											<h6 className="subtitle">TOKEN NAME</h6>
											<span className="subtext">Solchat</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">TOKEN SYMBOL</h6>
											<span className="subtext">$CHAT</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">MIN BUY</h6>
											<span className="subtext">5 SOL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">MAX BUY</h6>
											<span className="subtext">5 SOL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">HARDCAP</h6>
											<span className="subtext">500 SOL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">SOFTCAP</h6>
											<span className="subtext">250</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">TOKEN TYPE</h6>
											<span className="subtext">SPL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">WL </h6>
											<span className="subtext">True</span>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="pt-5">
				{/* <div className="container pt-lg-4">
					<h2 className="font-medium slider-title">
						Live and Upcoming token sales
					</h2>

					<div className="row g-4">
						{data?.map((item, i) => (
							<TokenItem key={i} item={item} i={i} />
						))}
					</div>
				</div> */}
			</div>
		</section>
		</>
	);
};

const data = [
	{
		img: "/img/mockimg.png",
		authorImg: "/img/logo3.png",
		date: "12 Aug 2024",
	},
	{
		img: "/img/mockimg.png",
		authorImg: "/img/logo3.png",
		live: true,
	},
	{
		img: "/img/mockimg.png",
		authorImg: "/img/logo3.png",
		live: true,
	},

];
export const chartdata = [
	{ name: "Mark", value: 90 },
	{ name: "Robert", value: 12 },
	{ name: "Emily", value: 34 },
];

export default TokenDetailsSection2;
